import loadingIcon from '@/assets/images/loading.svg';
import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
} from '@mui/material';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

export interface Props {
    progress: number;
    open: boolean;
    onClose: () => void;
}

function LoadingModal(props: Props) {
    const { t } = useTranslation();
    const { onClose, open, progress } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            classes={{
                paper: 'rounded-[25px] w-[500px] max-md:w-[330px]',
            }}
        >
            <IconButton
                aria-label="close"
                onClick={handleClose}
                className="absolute right-[12px] top-[12px] h-[24px] w-[24px]"
            >
                <CloseIcon style={{ fontSize: 16 }} />
            </IconButton>
            <DialogContent>
                <div className="mt-[40px] flex flex-col items-center gap-[5px]">
                    <div className="relative">
                        <img src={loadingIcon} alt="loading" />
                        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold">
                            {progress}%
                        </div>
                    </div>
                    <div className="mt-[20px] text-[18px]">
                        A new DAT enters LazAI.
                    </div>
                    <div className="text-[14px]">Minting in progress...</div>
                </div>
            </DialogContent>
            <DialogActions className="mb-[30px] justify-center p-0">
                <div className="m-auto flex h-[50px] w-[185px] items-center justify-center rounded-[20px] bg-primary text-[14px] font-normal normal-case text-white">
                    DAT Minting...
                </div>
            </DialogActions>
        </Dialog>
    );
}

export default observer(LoadingModal);
